import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [currentDocument, setCurrentDocumentState] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [activeTab, setActiveTab] = useState('mockPaper');
  const [generationResults, setGenerationResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [toast, setToast] = useState({ message: '', type: 'info', visible: false });

  // Add document to list if not present
  const setCurrentDocument = useCallback((doc) => {
    setCurrentDocumentState(doc);
    setDocuments(prev => {
      if (!doc || !doc.documentId) return prev;
      if (prev.some(d => d.documentId === doc.documentId)) return prev;
      return [...prev, doc];
    });
  }, []);

  // Reset results and tab when document changes
  useEffect(() => {
    setGenerationResults({});
    setActiveTab('mockPaper');
  }, [currentDocument]);

  // Optionally, provide a reset function
  const reset = useCallback(() => {
    setCurrentDocumentState(null);
    setDocuments([]);
    setGenerationResults({});
    setActiveTab('mockPaper');
    setLoading(false);
    setError('');
  }, []);

  const showToast = useCallback((message, type = 'info', duration = 3000) => {
    setToast({ message, type, visible: true });
    setTimeout(() => {
      setToast(t => ({ ...t, visible: false }));
    }, duration);
  }, []);

  return (
    <AppContext.Provider
      value={{
        currentDocument,
        setCurrentDocument,
        documents,
        setDocuments,
        activeTab,
        setActiveTab,
        generationResults,
        setGenerationResults,
        loading,
        setLoading,
        error,
        setError,
        reset,
        toast,
        showToast,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext); 